import styled from 'styled-components';
import { motion } from 'framer-motion';

export const FAQList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  max-width: 800px;
`;

export const FAQItem = styled.div`
  background: #ffffff;
  border-radius: 12px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.05);
  overflow: hidden;
`;

export const FAQQuestion = styled.button`
  width: 100%;
  background: none;
  border: none;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  padding: 1.5rem;
  font-size: 1.05rem;
  font-weight: 600;
  color: #1f2937;
  text-align: left;
  cursor: pointer;
  font-family: inherit;
`;

export const FAQChevron = styled(motion.span)`
  display: flex;
  align-items: center;
  color: #6b7280;
  flex-shrink: 0;
`;

export const FAQAnswer = styled(motion.div)`
  overflow: hidden;
`;

export const FAQAnswerText = styled.p`
  padding: 0 1.5rem 1.5rem;
  color: #6b7280;
  font-size: 0.95rem;
  line-height: 1.7;
`;

export const AccentBlob = styled.div`
  position: absolute;
  top: -1.5rem;
  right: -1.5rem;
  width: 70%;
  height: 70%;
  background: #d1ff94;
  border-radius: 32px;
  z-index: 0;

  @media (max-width: 968px) {
    display: none;
  }
`;
